import { z } from 'zod';

import { LoanInvestorRemittanceSplitId, LosId } from '../../BrandedIds';
import { zodTemporalPlainDate } from '../../Temporal';

/**
 * Direct passthrough of the internal `LoanInvestorRemittanceSplit` record — one per
 * remittance-split period on the loan. Investor identity (`investorName`, `investorLoanId`,
 * `ownerId`) is not on this object; that's on `ExportableLoan` (current) and
 * `ExportableExternalLoanId` (historical investorLoanId).
 */
export const ExportableLoanInvestorRemittanceSplit = z
  .object({
    id: LoanInvestorRemittanceSplitId,
    loanId: LosId,

    // Period bounds. soldDate unset = current split for the loan.
    startDate: zodTemporalPlainDate.optional(),
    soldDate: zodTemporalPlainDate.optional(),

    // 1:1 passthrough of LoanInvestorRemittanceSplit fields. When splitEnabled=false the share
    // fields hold the default 100%-servicer baseline; consumers check splitEnabled themselves
    // rather than us editorially omitting fields. Share/ownership values are percentages 0–100.
    splitEnabled: z.boolean(),
    investor: z.number(),
    servicer: z.number(),
    investor2: z.number().optional(),
    investorOwnership: z.number().optional(),
    investor2Ownership: z.number().optional(),
    guaranteeFee: z.number().optional(),
  })
  .meta({ title: 'LoanInvestorRemittanceSplit' });

export type ExportableLoanInvestorRemittanceSplit = z.infer<typeof ExportableLoanInvestorRemittanceSplit>;
